function applyDiscountCodeGMH(discountCode) {
  return fetch(`/discount/${discountCode}`, {
    method: 'GET'
  })
  .then(() => {
    window.location.href = '/checkout';
  })
  .catch(error => {
    console.error('Error applying discount code:', error);
    window.location.href = '/checkout';
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.add_to_cart_gmh').forEach(btn => {
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      console.log("we're on 123");
      if (this.dataset.clicked) return;
      this.dataset.clicked = 'true';

      let items = [];
      let discountCode = '';

      if (this.classList.contains('proo')) {
        items = [
          { id: 45238034825508, quantity: 1 },
          { id: 45238043246884, quantity: 1 }
        ];
        discountCode = 'DOMEPRO23';
      }
      else if (this.classList.contains('evoo')) {
        items = [
          { id: 45238037152036, quantity: 1 },
          { id: 45238044786980, quantity: 1 }
        ];
        discountCode = 'HAIR23';
      }
      else {
        console.warn('Unrecognized button class on .add_to_cart_gmh');
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add items to cart');
        }
        return response.json();
      })
      .then(() => {
        return applyDiscountCodeGMH(discountCode);
      })
      .catch(error => {
        console.error('Cart error:', error);
        window.location.href = '/checkout';
      });
    });
  });
});